/*
 * JHERR · Colecciones v25
 * - Muestra u oculta la oferta de cada tarjeta según la fecha real de la campaña
 *   (data-jh-start / data-jh-end, mismas fechas que el descuento de Shopify).
 *   No reinicia nada por visitante: todos ven la misma hora de cierre.
 * - Cuenta regresiva solo cuando faltan menos de 24 h.
 * - Limita la cantidad de etiquetas visibles por tarjeta.
 * - Barra "¿Te ayudamos?" en celular.
 * El descuento lo aplica y lo termina Shopify; este archivo solo refleja la fecha.
 * v26 (04-nov): el reloj de cada segundo actualiza solo las tarjetas que están en pantalla
 * (las demás se ponen al día al aparecer) y cada carga de "más productos" procesa solo la
 * tanda nueva. Antes, con cientos de tarjetas cargadas, se recorrían todas cada segundo.
 */
(function () {
  'use strict';
  if (window.JherrCollectionV25) return;
  window.JherrCollectionV25 = true;

  var LIMA_TZ = 'America/Lima';
  var ticking = null;

  function nowSec() { return Math.floor(Date.now() / 1000); }

  function limaDay(sec) {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: LIMA_TZ, year: 'numeric', month: '2-digit', day: '2-digit' })
        .format(new Date(sec * 1000));
    } catch (e) { return ''; }
  }

  function limaTime(sec) {
    try {
      return new Intl.DateTimeFormat('es-PE', { timeZone: LIMA_TZ, hour: '2-digit', minute: '2-digit', hour12: false })
        .format(new Date(sec * 1000));
    } catch (e) { return ''; }
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function updateShipping(card) {
    var note = card.querySelector('[data-jh-card-shipping]');
    if (!note) return;
    var price = Number(note.getAttribute('data-price-cents'));
    if (card.classList.contains('jh-card--campaign')) {
      var pct = Number(card.getAttribute('data-jh-pct')) || 0;
      price -= Math.round(price * pct / 100);
    }
    note.hidden = note.getAttribute('data-available') !== 'true' || !Number.isFinite(price) || price < 25000;
  }

  document.addEventListener('jherr:card-variant-change', function (event) {
    var card = event.target.closest('.jh-card');
    if (card) updateShipping(card);
  });

  function applyBadgeLimit(card) {
    var list = card.querySelector('.jh-badges');
    if (!list) return;
    var max = parseInt(list.getAttribute('data-jh-max') || '2', 10);
    var visible = [];
    Array.prototype.forEach.call(list.children, function (li) {
      li.classList.remove('is-over-limit');
      var hiddenByCampaign = li.hasAttribute('data-jh-campaign-only') && !card.classList.contains('jh-card--campaign');
      if (li.hidden || hiddenByCampaign) return;
      visible.push(li);
    });
    visible.sort(function (a, b) {
      return (parseInt(a.getAttribute('data-jh-prio') || '9', 10)) - (parseInt(b.getAttribute('data-jh-prio') || '9', 10));
    });
    visible.forEach(function (li, i) { if (i >= max) li.classList.add('is-over-limit'); });
  }

  function updateCard(card, now) {
    var start = parseInt(card.getAttribute('data-jh-start') || '0', 10);
    var end = parseInt(card.getAttribute('data-jh-end') || '0', 10);
    var active = start > 0 && end > 0 && now >= start && now < end;
    var was = card.classList.contains('jh-card--campaign');

    if (active !== was) card.classList.toggle('jh-card--campaign', active);
    updateShipping(card);

    if (active) {
      var left = end - now;
      var cd = card.querySelector('[data-jh-countdown]');
      if (cd) {
        var txt;
        if (left < 86400) {
          var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
          txt = 'Termina en ' + pad(h) + ':' + pad(m) + ':' + pad(s);
        } else {
          txt = 'Hasta el ' + limaDay(end).split('-').reverse().slice(0, 2).join('/') + ' a las ' + limaTime(end);
        }
        if (cd.textContent !== txt) cd.textContent = txt;
      }
      var today = limaDay(now);
      card.querySelectorAll('[data-jh-endday]').forEach(function (li) {
        var hide = li.getAttribute('data-jh-endday') !== today;
        if (li.hidden !== hide) li.hidden = hide;
      });
    }

    if (active !== was || !card.hasAttribute('data-jh-ready')) {
      card.setAttribute('data-jh-ready', '');
      applyBadgeLimit(card);
    }
    return end > now;
  }

  /* Tarjetas en pantalla (o a punto de entrar): solo esas se actualizan cada segundo */
  var onScreen = new Set();
  var lastEnd = 0;          /* el cierre más lejano entre las tarjetas con campaña */
  var screenIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    var now = nowSec();
    entries.forEach(function (en) {
      if (en.isIntersecting) { onScreen.add(en.target); updateCard(en.target, now); }
      else onScreen.delete(en.target);
    });
  }, { rootMargin: '300px 0px' }) : null;

  function tick() {
    var now = nowSec();
    if (screenIO) {
      onScreen.forEach(function (card) {
        if (!card.isConnected) { onScreen.delete(card); return; }
        updateCard(card, now);
      });
    } else {
      document.querySelectorAll('.jh-card[data-jh-campaign]').forEach(function (card) { updateCard(card, now); });
    }
    if (now >= lastEnd && ticking) { clearInterval(ticking); ticking = null; }
  }

  function cardsIn(scope) {
    if (!scope) return document.querySelectorAll('.jh-card');
    if (Array.isArray(scope)) {
      var out = [];
      scope.forEach(function (el) {
        if (el.matches && el.matches('.jh-card')) out.push(el);
        else if (el.querySelectorAll) Array.prototype.push.apply(out, el.querySelectorAll('.jh-card'));
      });
      return out;
    }
    return scope.querySelectorAll('.jh-card');
  }

  function init(scope) {
    var now = nowSec();
    Array.prototype.forEach.call(cardsIn(scope), function (card) {
      if (card.hasAttribute('data-jh-campaign')) {
        var end = parseInt(card.getAttribute('data-jh-end') || '0', 10);
        if (end > lastEnd) lastEnd = end;
        if (screenIO) screenIO.observe(card); else updateCard(card, now);
      } else {
        applyBadgeLimit(card);
        updateShipping(card);
      }
    });
    if (!ticking && lastEnd > now) ticking = setInterval(tick, 1000);
  }

  /* Tras agregar, el texto vuelve a minúsculas normales */
  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(function () {
      document.querySelectorAll('.jh-card .add-to-cart-text').forEach(function (t) {
        var b = t.closest('button');
        if (b && !b.disabled && /AGREGAR AL CARRITO/.test(t.textContent)) t.textContent = 'Agregar al carrito';
      });
    }, 1900);
  });

  /* Medición: vistas y clics de tarjetas en oferta (eventos personalizados de Shopify,
     visibles para píxeles personalizados). No envía nada si no hay campaña activa. */
  function publish(name, card) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, {
          productId: card.getAttribute('data-product-id'),
          campaignEnd: card.getAttribute('data-jh-end'),
          discountPct: card.getAttribute('data-jh-pct')
        });
      }
    } catch (e) {}
  }
  var seen = new WeakSet();
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var card = en.target;
      if (en.isIntersecting && card.classList.contains('jh-card--campaign') && !seen.has(card)) {
        seen.add(card);
        publish('jherr_promo_view', card);
      }
    });
  }, { threshold: 0.5 }) : null;
  function observe(scope) {
    if (!io) return;
    Array.prototype.forEach.call(cardsIn(scope), function (c) {
      if (c.hasAttribute('data-jh-campaign')) io.observe(c);
    });
  }
  document.addEventListener('click', function (event) {
    var card = event.target.closest('.jh-card.jh-card--campaign');
    if (card && event.target.closest('a, button')) publish('jherr_promo_click', card);
  }, true);

  document.addEventListener('jherr:collection-products-loaded', function (e) {
    var d = e.detail || {};
    var scope = d.items && d.items.length ? d.items : d.container;
    observe(scope);
    init(scope);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    tick();
    if (!ticking && lastEnd > nowSec()) ticking = setInterval(tick, 1000);
  });

  /* Barra "¿Te ayudamos?" (celular): abre el chat de ayuda que ya tiene la tienda.
     Si el chat no cargó, lleva a la página de contacto. */
  if (document.querySelector('[data-jh-help]')) document.documentElement.classList.add('jh-helpbar-on');
  document.addEventListener('click', function (event) {
    var help = event.target.closest('[data-jh-help]');
    if (!help) return;
    var chat = document.querySelector('#sweet-help-chat-box .sweethelp-chat-button-area');
    if (chat) {
      chat.click();
    } else {
      window.location.href = '/pages/contact';
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); observe(); });
  } else {
    init();
    observe();
  }
})();
